import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import FlightOrderCard from "./FlightOrderCard/FlightOrderCard";
import "../index.css";

function TboOrderCard({ order, ...props }) {
  const { flight_data } = order;

  function createUTCdateForISO(dateString) {
    const offset = new Date().getTimezoneOffset();
    const myDate = Date.parse(dateString) + offset * 60 * 1000;
    const dateAsISO = new Date(myDate).toISOString();
    return dateAsISO;
  }

  const addSeconds = (DateValue, TimeValue) => {
    if (TimeValue.split(":").length < 3) {
      TimeValue = TimeValue + ":00";
    }
    return DateValue + "T" + TimeValue + ".000Z";
  };

  const flightOrder = {
    status: order?.status?.toUpperCase(),
    order_amount: order?.order_amount,
    amount: order?.amount,
    currency: order?.vendorDetails?.at(0)?.currency || "INR",
    booking_id: order?.booking_id,
    vendorDetails: order?.vendorDetails?.at(0),
    createdAt: order?.createdAt,
    updatedAt: order?.updatedAt,
    flight_data: flight_data && {
      origin: flight_data.origin,
      destination: flight_data.destination,
      segments:
        flight_data.segments &&
        flight_data.segments.map((segment) => ({
          airline: flight_data.flight_number?.split(" ")[0],
          local_departure:
            flight_data.departure_date &&
            flight_data.departure_time &&
            addSeconds(segment.departure_date, segment.departure_time),
          utc_departure:
            flight_data.departure_date &&
            flight_data.departure_time &&
            addSeconds(segment.departure_date, segment.departure_time),
          local_arrival:
            flight_data.arrival_date &&
            flight_data.arrival_time &&
            addSeconds(segment.arrival_date, segment.arrival_time),
          utc_arrival:
            flight_data.arrival_date &&
            flight_data.arrival_time &&
            addSeconds(segment.arrival_date, segment.arrival_time),
          flyFrom: segment.origin,
          flyTo: segment.destination,
          fare_category: "M",
          flight_no: segment.flight_number?.split(" ")?.at(-1),
        })),
    },
    passenger_data: [
      ...(order?.passenger_data?.map((info) => ({
        title: info.title,
        name: info.name,
        surname: info.last_name,
        email: info?.email || order?.email,
        phone: info?.phone || order?.phone,
        birthday: info?.birthday,
        nationality: info?.nationality,
        category: info?.category,
      })) || []),
      ...(order?.child_info?.map((info) => ({
        title: info.title,
        name: info.name,
        surname: info.last_name,
        email: info?.email || order?.email,
        phone: info?.phone || order?.phone,
        birthday: info?.birthday,
        nationality: info?.nationality,
        category: info?.category,
      })) || []),
      ...(order?.infant_info?.map((info) => ({
        title: info.title,
        name: info.first_name,
        surname: info.last_name,
        email: info?.email || order?.email,
        phone: info?.phone || order?.phone,
        birthday: info?.birthday,
        nationality: info?.nationality,
        category: info?.category,
      })) || []),
    ],
  };

  return <FlightOrderCard props={props} order={flightOrder} />;
}

export default TboOrderCard;
